import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import Button from '../components/Button'
import InfoBox from '../components/InfoBox'
import { MeasurementInput, UnitToggle } from '../components/MeasurementInput'
import PageLayout from '../components/PageLayout'

interface MeasurementPageProps {
  heading: string
  description: string
  placeholders: Record<string, string>
  units: string[]
  defaultUnit?: string
  onSubmit: (
    value: string,
    unit: string,
    event: React.FormEvent<HTMLFormElement>,
  ) => void
  preselectedValue?: string
}

export default function MeasurementPage({
  heading,
  description,
  placeholders,
  units,
  defaultUnit,
  onSubmit,
  preselectedValue,
}: MeasurementPageProps) {
  const { t } = useTranslation()
  const [value, setValue] = useState(preselectedValue || '')
  const [unit, setUnit] = useState(defaultUnit || units[0])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!value || isNaN(Number(value)) || Number(value) <= 0) return
    onSubmit(value, unit, event)
  }

  return (
    <PageLayout>
      <Form
        className="flex grow flex-col"
        method="post"
        onSubmit={handleSubmit}
      >
        <div>
          <h1 className="custom-heading text-center text-3xl font-bold whitespace-pre-line">
            {heading}
          </h1>
        </div>

        <div className="flex grow flex-col items-center justify-center">
          <div className="w-full max-w-[500px] space-y-10">
            <InfoBox>
              <p className="text-base">{description}</p>
            </InfoBox>

            <div className="flex flex-col items-center space-y-6">
              <MeasurementInput
                value={value}
                onChange={setValue}
                unit={unit}
                placeholder={placeholders[unit] || ''}
              />

              <UnitToggle
                units={units}
                selectedUnit={unit}
                onUnitChange={setUnit}
              />
            </div>
          </div>
        </div>

        <div>
          <Button
            title={t('buttons.continue')}
            type="submit"
            data-testid="button-continue-input"
            disabled={!value || isNaN(Number(value)) || Number(value) <= 0}
          />
        </div>
      </Form>
    </PageLayout>
  )
}
